<template>
  <div>
    <h2 class="intro-y text-lg font-medium mt-10">Offences</h2>
    <div class="grid grid-cols-12 gap-6 mt-5">
      <!-- BEGIN: Offences Cards -->
      <OffenceCard
        v-for="(offence, key) in offences"
        :key="key"
        :title="offence.name"
        :count="offence.cases_count"
        :percentage="Math.abs(offence.mnth_on_mnth)"
        :increase="offence.mnth_on_mnth > 0"
        :typeId="offence.id"
      />
      <!-- END: Offences Cards -->
      <!-- BEGIN: Pagination -->
      <div
        v-show="totalPages > 0"
        class="intro-y col-span-12 flex flex-wrap sm:flex-row sm:flex-no-wrap items-center"
      >
        <ul class="pagination">
          <li>
            <button class="pagination__link" @click="gotoPage(1)">
              <ChevronsLeftIcon class="w-4 h-4" />
            </button>
          </li>
          <li>
            <button class="pagination__link" @click="prevPage">
              <ChevronLeftIcon class="w-4 h-4" />
            </button>
          </li>
          <li>
            <button class="pagination__link" @click="nextPage">
              <ChevronRightIcon class="w-4 h-4" />
            </button>
          </li>
          <li>
            <button class="pagination__link" @click="gotoPage(totalPages)">
              <ChevronsRightIcon class="w-4 h-4" />
            </button>
          </li>
        </ul>
      </div>
      <!-- END: Pagination -->
    </div>
  </div>
</template>

<script>
import axios from "axios";
import OffenceCard from "@/components/OffenceCard";

export default {
  name: "OffencesCards",
  components: {
    OffenceCard
  },
  data() {
    return {
      offences: [],
      host_url: process.env.VUE_APP_CCD_CLIENT_URL,
      current_page: 1,
      page_size: 50,
      sortedList: [],
      message: "Loading...",
      total: 0,
      totalPages: 0,
      from: 0,
      to: 0
    };
  },
  computed: {
    filterParams() {
      return this.$store.state.filtersMenu.selectedFilters;
    }
  },
  watch: {
    "$store.state.filtersMenu.count": {
      handler: function() {
        this.getOffences();
      }
    }
  },
  mounted() {
    this.getOffences();
  },
  methods: {
    loadMore() {
      this.page++;
      this.getOffences();
    },
    getOffences() {
      axios
        .get(`${window.host}/api/offences`, {
          params: { ...this.filterParams, page: this.current_page }
        })
        .then(response => {
          if (response.data) {
            this.offences = Object.keys(response.data).map(
              i => response.data[i]
            );
            this.offences.sort((a, b) => {
              return b.cases_count - a.cases_count;
            });
            this.total = response.data.total;
            this.totalPages = response.data.last_page;
            this.from = response.data.from;
            this.to = response.data.to;
          }
        });
    },
    gotoPage(index) {
      if (this.current_page == index) return;

      this.current_page = index;
      this.getOffences();
    },
    nextPage() {
      if (this.current_page < this.totalPages) {
        this.current_page++;
        this.getOffences();
      }
    },
    prevPage() {
      if (this.current_page > 1) {
        this.current_page--;
        this.getOffences();
      }
    }
  }
};
</script>
